import { gql } from '@apollo/client';

export const FILTERED_REASON_FOR_CLOSURES = gql`
  query filteredReasonForClosures($input: FilterReasonForTermination!) {
    filteredReasonForClosures(input: $input) {
      id
      name
    }
  }
`;
